import React from "react";

export const EMAIL_STATS_STATUS_CLASS: Record<string, string> = {
  Processed: "bg-gray-100 text-gray-700 border border-gray-700",
  Processing: "bg-blue-100 text-blue-800 border border-blue-800",
  Pending: "bg-gray-100 text-gray-600 border border-gray-600",
  Scheduled: "bg-slate-100 text-slate-700 border border-slate-700",
  Delivered: "bg-green-100 text-green-800 border border-green-800",
  Opened: "bg-teal-100 text-teal-800 border border-teal-800",
  Clicked: "bg-violet-100 text-violet-800 border border-violet-800",
  Failed: "bg-red-100 text-red-800 border border-red-800",
  Bounced: "bg-orange-100 text-orange-800 border border-orange-800",
  FilteredSpam: "bg-amber-100 text-amber-800 border border-amber-800",
  Quarantined: "bg-amber-100 text-amber-900 border border-amber-900",
  Suppressed: "bg-rose-100 text-rose-800 border border-rose-800",
  Expanded: "bg-sky-100 text-sky-800 border border-sky-800",
  Cancelled: "bg-gray-100 text-gray-500 border border-gray-500",
};

const FALLBACK_CLASS =
  "bg-gray-100 text-gray-700 border border-gray-700";

export default function EmailStatsStatusBadge ({
  status,
}: {
  status?: string;
}): React.ReactElement {
  const value = String(status || "").trim();
  if (!value) {
    return <></>;
  }
  const className = EMAIL_STATS_STATUS_CLASS[value] ?? FALLBACK_CLASS;
  return (
    <span
      className={`inline-flex rounded-full px-2.5 py-0.5 text-xs font-medium ${className}`}
    >
      {value}
    </span>
  );
}
